import { buttonVariants } from "@takt/web-ui/components/button"
import { Card } from "@takt/web-ui/components/card"
import { TaktMark } from "@takt/web-ui/components/takt-mark"
import { createFileRoute } from "@tanstack/react-router"
import { buildAccountUrl } from "@/app/auth"

export const Route = createFileRoute("/forbidden")({ component: ForbiddenPage })

function ForbiddenPage() {
    return (
        <main className="admin-grid grid min-h-screen place-items-center p-6">
            <Card className="w-full max-w-md p-6 text-center">
                <TaktMark className="mx-auto" size="lg" variant="beat" />
                <p className="mt-5 text-sm font-semibold text-destructive">Access denied</p>
                <h1 className="mt-1 text-xl font-bold">Administrator access is required</h1>
                <p className="mt-2 text-sm leading-6 text-muted-foreground">
                    You are signed in, but this account does not have the platform administrator role.
                </p>
                <a className={buttonVariants({ className: "mt-5 w-full no-underline" })} href={buildAccountUrl()}>
                    Open Groomio Account
                </a>
            </Card>
        </main>
    )
}
